import React from "react";
import "../styles/FAQ.css";

const faqs = [
  {
    q: "Do you need access to our SAP system?",
    a: "Not to start. The free proof of concept works from a CSV export. For full builds I connect the way your IT team approves: SAP extracts, read-only access, your data warehouse or Microsoft Fabric.",
  },
  {
    q: "Is our data secure?",
    a: "Full builds run in your own Microsoft tenant. The data gateway sits on your server or VPC, row-level security controls who sees what, and I'm happy to sign an NDA before seeing any data.",
  },
  {
    q: "What about Power BI licences?",
    a: "Licences are billed by Microsoft, not by me. I'll tell you exactly what you need (Power BI Pro, Premium Per User or Fabric capacity) based on how many people will use the reports.",
  },
  {
    q: "How long does a project take?",
    a: "It depends on scope, so you get a timeline after the discovery call. The free proof of concept comes first, so you see results before you pay anything.",
  },
  {
    q: "Who owns the dashboards and code?",
    a: "You do. You receive the Power BI files, Python code and documentation.",
  },
  {
    q: "What does \"agentic BI\" mean?",
    a: "Automation and AI around your reports: scheduled email reports, alerts when a KPI moves, mismatch checks between systems, and AI-assisted validation and documentation, so reports stay correct and reach people without manual work.",
  },
];

export default function FAQ() {
  return (
    <section id="faq">
      <div className="section-header">
        <span className="section-title">FAQ</span>
      </div>
      <div className="faq-list">
        {faqs.map((item) => (
          <details key={item.q} className="faq-item">
            <summary>{item.q}</summary>
            <p>{item.a}</p>
          </details>
        ))}
      </div>
    </section>
  );
}
